export default __webpack_public_path__ + "static/Yacine-03482a783c0939dabbb87eba730e2848.jpg";